"use client"

export default function OrganizationSkeleton() {
  return (
    <div className="w-full mx-auto px-2 md:px-4 md:pb-20 pb-10 pt-2 font-sans">
      <div className="rounded-3xl bg-white shadow-sm border border-gray-100 p-3 md:p-6 relative overflow-hidden min-h-[400px]">
        <div className="mb-8 md:mb-10">
          <div className="h-6 w-56 bg-gray-100/80 animate-pulse rounded-md rounded-md animate-pulse" />
          <div className="mt-2 h-4 w-80 bg-gray-100/80 animate-pulse rounded-md rounded-md animate-pulse" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4 mt-2 relative z-10">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center gap-3 px-5 py-6 rounded-2xl border border-gray-100 bg-white transition-all duration-300 relative overflow-hidden"
            >
              <div className="w-16 h-16 rounded-full bg-gray-100/80 animate-pulse rounded-md mb-1 animate-pulse" />
              <div className="w-full">
                <div className="h-4 bg-gray-100/80 animate-pulse rounded-md rounded-md w-3/4 mx-auto animate-pulse" />
                <div className="mt-2 h-3 bg-gray-100/80 animate-pulse rounded-md rounded-md w-2/3 mx-auto animate-pulse" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
